export const currencyActionType = {
  SAGA_GET_LATEST_EXCGHANGE_RATES: 'SAGA_GET_LATEST_EXCGHANGE_RATES'
}

export function sagaGetLatestExchangeRates() {
  return {
    type: currencyActionType.SAGA_GET_LATEST_EXCGHANGE_RATES,
  }
}
